import React from 'react';
import style from './collapsableSections.module.scss';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { ExpandAllProps, TitleProps } from 'acscp/components/common/collapsable';
import { ArrowIcon } from 'acscp/components/common/icons/arrowIcon';
import { scrollToElement } from 'acscp/components/common/helpers/scrollHelper';

const ExpandAll: React.SFC<ExpandAllProps> = ({collapsed, setCollapsed = () => {}}) => (
    <div
        className={classNames(style.ExpandAll, {[style.AllExpanded]: !collapsed})}
        onClick={() => setCollapsed(!collapsed)}
    >
        {collapsed
            ? <FormattedMessage
                id={'components.itinerary.collapsableSections.expandAll'}
                defaultMessage={'Expand All'}
            />
            : <FormattedMessage
                id={'components.itinerary.collapsableSections.collapseAll'}
                defaultMessage={'Collapse All'}
            />
        }
        <div className={style.ExpandAllIcon} />
    </div>
);

class Title extends React.Component<TitleProps & {className?: string}, {}> {
    title: HTMLElement | null;

    setCollapsed(collapsed: boolean): void {
        if (this.props.setCollapsed) {
            this.props.setCollapsed(collapsed);
        }

        if (!collapsed) {
            scrollToElement(this.title);
        }
    }

    render(): JSX.Element {
        const {className, collapsed, children} = this.props;
        return (
            <div
                className={classNames(style.Title, className, {[style.Hidden]: collapsed})}
                onClick={() => this.setCollapsed(!collapsed)}
                ref={ref => this.title = ref}
            >
                <ArrowIcon />
                {children}
            </div>
        );
    }
}

export { ExpandAll, Title };
